var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRightAero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 13,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.95 6.364 0 1.414 1.414 0l6.364 6.364-6.364 6.364L0 11.314z",
    fill: "#FFF",
    fillRule: "nonzero"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightAero);
export default __webpack_public_path__ + "static/media/right-aero.7c452d3d1c24b37aa703c55626e54455.svg";
export { ForwardRef as ReactComponent };